import { startOfDay, isSameDay } from 'date-fns'
import { Schemas } from '~/api/gen'
import { CommentBubble } from '~/components/modules/CommentBubble'
import { CommentDate } from '~/components/modules/CommentDate'
import { dedup } from '~/lib/dedup'

type Props = {
  comments: Schemas.coordinate_comment_with_member[]
  memberId: number
}

export const CommentList: React.FC<Props> = ({ memberId, comments }) => {
  const commentedDates = dedup(
    comments.map((comment) =>
      startOfDay(new Date(comment.created_at)).valueOf()
    )
  ).map((date) => new Date(date))

  return (
    <div className="flex flex-col gap-4 pt-[17px] xl:pt-2">
      {commentedDates.map((date) => {
        return (
          <div key={date.valueOf()}>
            <CommentDate date={date} />
            <div className="flex flex-col gap-4">
              {comments.map((comment) => {
                if (!isSameDay(new Date(comment.created_at), date)) return null
                return (
                  <CommentBubble
                    key={comment.id}
                    member={comment.member}
                    createdAt={comment.created_at}
                    text={comment.comment}
                    speechFromLeft={memberId !== comment.member.id}
                  />
                )
              })}
            </div>
          </div>
        )
      })}
    </div>
  )
}
